import * as React from 'react'
import {
  Stack,
  FieldLabel,
  FieldValue,
  TextInput,
  TextAreaInput,
} from '@lightspeed/design-system-react'
import { ServiceItem } from '../../../../../../models/sale.constants'
import { INPUT_MAX_CHAR, TEXT_AREA_MAX_CHAR } from '../../constants'

interface Props {
  itemDetailsInputs: ItemDetailsInputs | ServiceItem
  handleInputChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
}

interface ItemDetailsInputs {
  itemName: string
  serialNumber: string
  description: string
  initialCondition: string
}

export const ItemInputForm: React.FC<Props> = ({
  itemDetailsInputs,
  handleInputChange,
}) => {
  return (
    <form data-testid="item-input-form">
      <Stack space={5} pt={5}>
        <Stack space={0}>
          <FieldLabel
            label="Item name"
            htmlFor="itemName"
            supplementaryLabel="Required"
          />
          <FieldValue>
            <TextInput
              autoComplete="off"
              placeholder="Enter item name"
              id="itemName"
              name="itemName"
              value={itemDetailsInputs.itemName}
              required
              onChange={handleInputChange}
              maxLength={INPUT_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0} style={{ width: '50%' }}>
          <FieldLabel label="Serial number" htmlFor="serialNumber" />
          <FieldValue>
            <TextInput
              autoComplete="off"
              placeholder="Enter serial number"
              id="serialNumber"
              name="serialNumber"
              value={itemDetailsInputs.serialNumber}
              onChange={handleInputChange}
              maxLength={INPUT_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0}>
          <FieldLabel
            label="Description"
            htmlFor="description"
            supplementaryLabel="Include make, model, color or any accessories"
          />
          <FieldValue>
            <TextAreaInput
              autoComplete="off"
              placeholder="Enter description"
              id="description"
              name="description"
              value={itemDetailsInputs.description}
              onChange={handleInputChange}
              maxLength={TEXT_AREA_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
        <Stack space={0}>
          <FieldLabel
            label="Condition"
            htmlFor="initialCondition"
            supplementaryLabel="Include any visible damage to the customer item"
          />
          <FieldValue>
            <TextAreaInput
              autoComplete="off"
              placeholder="Enter condition"
              id="initialCondition"
              name="initialCondition"
              value={itemDetailsInputs.initialCondition}
              onChange={handleInputChange}
              maxLength={TEXT_AREA_MAX_CHAR}
            />
          </FieldValue>
        </Stack>
      </Stack>
    </form>
  )
}
